<template lang="html">
    <entity-page id="page__status-reason" v-loader-overlay="progress">
        <template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded @click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded @click="save"></z-icon-button>
        </template>
        <div class="row">
            <z-select
                v-model="reason.status_id" v-validate="{required: true}" class="col-6"
                v-bind="{
                    id: 'status_id', name: 'status_id', label: 'Статус',
                    'data-vv-as': ' ', 'data-vv-name': 'status_id', error: errors.first('status_id')
                }"
            >
                <option value="" selected disabled>Не укстановлен</option>
                <option v-for="statuse in statuses" v-bind:value="statuse.id"> {{statuse.name}} </option>
            </z-select>

            <z-select
                v-model="reason.comment_require" v-validate="{required: true}" class="col-6"
                v-bind="{
                    label: 'Обязательность комментария при установке статуса',
                    id: 'comment_require', name: 'comment_require',
                    'data-vv-as': ' ', 'data-vv-name': 'comment_require',
                    error: errors.first('comment_require')
                }"
            >
                <option value="" selected disabled>Не укстановленно</option>
                <option v-bind:value="0">Нет</option>
                <option v-bind:value="1">Да</option>
            </z-select>
            
            <z-input
                v-model="reason.name" v-validate="{required: true, min: 4, max: 255}" class="col-6"
                v-bind="{
                    name: 'name', id: 'name', label: 'Название',
                    'data-vv-name': 'name', 'data-vv-as': ' ', error: errors.first('name')
                }"
            ></z-input>
            <z-input
                v-model="reason.code" v-validate="{required: true, min: 4, max: 255}" class="col-6"
                v-bind="{
                    id: 'code', name: 'code', label: 'Символьный уникальный код',
                    'data-vv-name': 'code', 'data-vv-as': ' ', error: errors.first('code')
                }"
            ></z-input>
        </div>
    </entity-page>
</template>
<script>
    import ZInput      from '@/components/ZInput';
    import ZSelect     from '@/components/ZSelect';
    import ZIconButton from '@/components/ZIconButton';
    import EntityPage  from '@/components/EntityPage.vue';
    export default {
        components: {ZInput, ZSelect, ZIconButton, EntityPage},
        data() {
            return {
                reason: {},
                defaultReason: {
                    id: null,
                    code: null,
                    type: 0,
                    comment_require: '',
                    name: null,
                    status_id: null,
                },
                statuses: [],
            }
        },
        watch: {
            '$route.params.reason_id'() {
                this.init();
            },
        },
        created() {
            this.init();
            this.listeners();
            this.getStatuses();
        },
        methods: {
            /**
             * Инициализация компонента
             */
            init() {
                this.$store.commit('openRightPanel');
                if (this.$route.params.reason_id != 'new') this.getReason();
                else this.reason = Object.assign({}, this.defaultReason);
            },
            /**
             * Возвращает пользователя на предидущую страницу
             */
            back() {
                this.$router.push({name: 'StatusReasons', query: this.$route.query});
            },
            listeners() {
                this.$root.$on('update-reason-form', id => {
                    if (parseInt(id) === parseInt(this.$route.params.reason_id)) this.init();
                });
            },
            /**
             * Добавление Признака
             */
            postReason() {
                this.$store.commit('showProgressBar', 'load-reason-card');
                this.$store.dispatch('deals/postStatusReason', this.reason).then(r => {
                    if (!r) return;
                    this.$root.$emit('reload-table', 'reasons');
                    this.$router.replace({name: 'StatusReason', params: {reason_id: r.id}});
                }).finally(() => this.$store.commit('hideProgressBar', 'load-reason-card'));
            },
            /**
             * Изменение признака
             */
            putReason() {
                this.$store.commit('showProgressBar', 'load-reason-card');
                this.$store.dispatch('deals/putStatusReason', this.reason).then(r => {
                    if (!r) return;
                    this.init();
                    this.$root.$emit('reload-table', 'reasons');
                }).finally(() => this.$store.commit('hideProgressBar', 'load-reason-card'));
            },
            /**
             * Сохранение признака
             */
            save() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    if (this.$route.params.reason_id != 'new') this.putReason();
                    else this.postReason();
                })
            },
            /**
             * Получение статусов
             */
            getStatuses() {
                this.$store.commit('showProgressBar', 'load-reason-card');
                return this.$store.dispatch('deals/getAllStatuses').then(statuses => {
                    if (statuses) this.statuses = Object.assign({}, statuses);
                }).finally(() => this.$store.commit('hideProgressBar', 'load-reason-card'));
            },
            /**
             * Получение признаков
             */
            getReason() {
                this.$store.commit('showProgressBar', 'load-reason-card');
                return this.$store.dispatch('deals/getStatusReason', this.$route.params.reason_id).then(reason => {
                    if (reason) this.reason = Object.assign({}, reason);
                }).finally(() => this.$store.commit('hideProgressBar', 'load-reason-card'));
            },
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['load-reason-card'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            }
        }
    }
</script>
<style src="./Deal.sass" lang="sass"></style>


// WEBPACK FOOTER //
// StatusReason.vue?22787e58